import { render, staticRenderFns } from "./LocaleLink.vue?vue&type=template&id=c796d394&"
import script from "./LocaleLink.vue?vue&type=script&lang=js&"
export * from "./LocaleLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports